module.exports = __webpack_public_path__ + "img/atms-1.e99be85f.png";